import { UserService } from "services/UserService";

export const updateLastSelection = (user: any, authId: string) => {
  const User = new UserService(authId);
  User.updateUser({
    lastClientSelection: user,
  }).catch((err) => console.log("lastSelection Error", err));
};
